export default {
  cancel: {
    defaultMessage: 'Cancel',
    description: 'multiple select bar | cancel button label',
  },
  selectedAssetsCounter: {
    defaultMessage: '{count} Assets selected',
    description: 'multiple select bar | assets counter',
  },
  share: {
    defaultMessage: 'Share',
    description: 'multiple select bar | share button',
  },
  selectedSmartSharesCounter: {
    defaultMessage: '{count} Smart Shares selected',
    description: 'multiple select bar | smart shares counter',
  },
  cancelSmartShares: {
    defaultMessage: 'Cancel Smart Shares',
    description: 'multiple select bar | cancel smart shares button',
  },
  cannotShareOfflineAssets: {
    defaultMessage: 'Cannot share offline assets {offlineAssets}',
    description: 'multiple select bar | cannot share offline assets',
  },
} as const
